// extracted by mini-css-extract-plugin
export default {"details":"DetailsFood_details__mpszp"};